
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/horoshop-integration",
      function () {
        return require("private-next-pages/horoshop-integration.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/horoshop-integration"])
      });
    }
  